"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var Localize_1 = require("../../../gen-src/Localize");
var TableBreadcrumbsUpdater_1 = require("../breadcrumbs/TableBreadcrumbsUpdater");
var BrowserTitleUpdater_1 = require("../BrowserTitleUpdater");
var ColumnDetailsDialog_1 = require("../ColumnDetails/ColumnDetailsDialog");
var ErrorListProvider_1 = require("../error/components/ErrorListProvider");
var ErrorToasts_1 = require("../error/components/ErrorToasts");
var UnrecognizedUrl_1 = require("../error/components/UnrecognizedUrl");
var LineageItemType_1 = require("../lineage/LineageItemType");
var LineageConfiguration_1 = require("../placePage/LineageConfiguration");
var LineageSubplaceLayout_1 = require("../placePage/LineageSubplaceLayout");
var TableLineageConfiguration_1 = require("./TableLineageConfiguration");
var TableLineageCountsQueryWrapper_1 = require("./TableLineageCountsQueryWrapper");
var TablePlacePageHeader_1 = require("./TablePlacePageHeader");
var TableQueryWrapper_1 = require("./TableQueryWrapper");
var TableSubplaceParamsProvider_1 = require("./TableSubplaceParamsProvider");
var TablePlacePage = /** @class */ (function (_super) {
    __extends(TablePlacePage, _super);
    function TablePlacePage(props) {
        var _this = _super.call(this, props) || this;
        _this.localIsMounted = false;
        _this.rerenderTablePlacePage = function () {
            if (_this.localIsMounted) {
                _this.setState({
                    hackyUpdateNumber: _this.state.hackyUpdateNumber + 1
                });
            }
        };
        _this.renderRoute = function (urls, lineageItem, lineageSection) {
            return (React.createElement(TableSubplaceParamsProvider_1.TableSubplaceParamsProvider, null, function (params) {
                return React.createElement(ErrorListProvider_1.ErrorListProvider, null,
                    React.createElement(ErrorToasts_1.ErrorToasts, null),
                    React.createElement(TableQueryWrapper_1.TableQueryWrapper, { tableId: _this.props.tableId }, function (table) {
                        return React.createElement(TableLineageCountsQueryWrapper_1.TableLineageCountsQueryWrapper, { tableId: _this.props.tableId, selectedColumnKeys: params.selectedColumns }, function (_a) {
                            var countsLoading = _a.countsLoading, unfilteredCounts = _a.unfilteredCounts, filteredCounts = _a.filteredCounts;
                            return React.createElement(React.Fragment, null,
                                React.createElement(TableBreadcrumbsUpdater_1.TableBreadcrumbsUpdater, { tableId: _this.props.tableId, tableName: table.name, databaseId: table.__typename === 'DatabaseTable' && table.database ? table.database.id : null, databaseName: table.__typename === 'DatabaseTable' && table.database ? table.database.name : null }),
                                React.createElement(BrowserTitleUpdater_1.BrowserTitleUpdater, { name: table.name, browserTitleUpdateType: BrowserTitleUpdater_1.BrowserTitleUpdateType.TITLE_WITH_PLACE_ENTITY_NAME }),
                                React.createElement(data_catalog_shared_1.VerticalFlexContainer, { fillFlexParent: true },
                                    React.createElement(data_catalog_shared_1.ApiRequestsContext.Consumer, null, function (apiRequests) {
                                        return React.createElement(TablePlacePageHeader_1.TablePlacePageHeader, { apiRequests: apiRequests, newWorkbookFromCatalog: _this.props.newWorkbookFromCatalog, table: table });
                                    }),
                                    React.createElement(TableLineageSubplace, { tableId: _this.props.tableId, table: table, lineageItem: lineageItem, lineageSection: lineageSection, countsLoading: countsLoading, unfilteredCounts: unfilteredCounts, filteredCounts: filteredCounts, urlSearchValue: params.urlSearchValue, selectedKeys: params.selectedColumns, updateSelectionForKey: params.updateColumnSelection, clearColumnSelection: params.clearColumnSelection, hackyUpdateNumber: _this.state.hackyUpdateNumber })),
                                lineageSection.sectionType === LineageConfiguration_1.LineageSectionType.Anchor ?
                                    React.createElement(react_router_dom_1.Route, { path: urls.catalogTableColumnPath(_this.props.tableId, ':columnId'), render: function (_a) {
                                            var history = _a.history, location = _a.location, match = _a.match;
                                            return React.createElement(ColumnDetailsDialog_1.ColumnDetailsDialog, { columnId: match.params.columnId, tableVizportalId: table.__typename === 'DatabaseTable' ? table.vizportalId : null, onClose: function () { return history.replace(__assign(__assign({}, location), { pathname: urls.catalogTableColumnsPath(_this.props.tableId) })); }, onUpdate: _this.rerenderTablePlacePage });
                                        } })
                                    : null);
                        });
                    }));
            }));
        };
        _this.state = {
            hackyUpdateNumber: 0
        };
        return _this;
    }
    TablePlacePage.prototype.componentDidMount = function () {
        this.localIsMounted = true;
    };
    TablePlacePage.prototype.componentWillUnmount = function () {
        this.localIsMounted = false;
    };
    TablePlacePage.prototype.render = function () {
        var _this = this;
        return (React.createElement(data_catalog_shared_1.SiteUrlsContext.Consumer, null, function (urls) {
            return React.createElement(react_router_dom_1.Switch, null,
                TableLineageConfiguration_1.TableLineageConfiguration.map(function (lineageSection) {
                    return lineageSection.items.map(function (lineageItem) {
                        return React.createElement(react_router_dom_1.Route, { path: lineageItem.path(urls, _this.props.tableId), render: function () { return _this.renderRoute(urls, lineageItem, lineageSection); } });
                    });
                }),
                React.createElement(react_router_dom_1.Redirect, { exact: true, from: urls.catalogTablePath(_this.props.tableId), to: urls.catalogTableColumnsPath(_this.props.tableId) }),
                React.createElement(UnrecognizedUrl_1.UnrecognizedUrl, { backToButtonLabel: Localize_1.Messages.BackToTable(), backToButtonUrl: urls.catalogTablePath(_this.props.tableId) }));
        }));
    };
    return TablePlacePage;
}(React.Component));
exports.TablePlacePage = TablePlacePage;
var TableLineageSubplace = /** @class */ (function (_super) {
    __extends(TableLineageSubplace, _super);
    function TableLineageSubplace() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableLineageSubplace.prototype.render = function () {
        var selectedColumns = Object.keys(this.props.selectedKeys);
        var hasFilter = selectedColumns.length > 0;
        var filteredColumnId = hasFilter ? selectedColumns[0] : null;
        var lineageCounts = this.props.filteredCounts ? this.props.filteredCounts : this.props.unfilteredCounts;
        return (React.createElement(LineageSubplaceLayout_1.TableLineageSubplaceLayout, { activeLineageItemKey: LineageConfiguration_1.lineageItemKey(this.props), selectedAnchorItemIds: selectedColumns, pane: this.props.lineageItem.paneFactory({
                title: data_catalog_shared_1.messageWithOrWithoutCount(lineageCounts && this.props.lineageItem.count(lineageCounts), this.props.lineageItem.messagesForPane),
                table: this.props.table,
                tableId: this.props.tableId,
                filteredColumnId: filteredColumnId,
                count: lineageCounts && this.props.lineageItem.count(lineageCounts),
                selectedKeys: this.props.selectedKeys,
                updateSelectionForKey: this.props.updateSelectionForKey,
                hackyUpdateNumber: this.props.hackyUpdateNumber
            }), tableId: this.props.tableId, countsLoading: this.props.countsLoading, unfilteredCounts: this.props.unfilteredCounts, filteredCounts: this.props.filteredCounts, urlSearchValue: this.props.urlSearchValue, clearColumnSelection: this.props.clearColumnSelection, anchorName: this.props.table.name, anchorCount: LineageConfiguration_1.getAnchorCountFromConfig(TableLineageConfiguration_1.TableLineageConfiguration, this.props.unfilteredCounts), filteredOnItemType: hasFilter ? LineageItemType_1.LineageItemType.Table : null }));
    };
    return TableLineageSubplace;
}(React.PureComponent));
//# sourceMappingURL=TablePlacePage.js.map